export const NORMALIZED_BORDER_STYLES = ['solid', 'dashed', 'dotted', 'double', 'none'] as const;

export type TNormalizedBorderStyle = (typeof NORMALIZED_BORDER_STYLES)[number];

export const normalizeBorderStyle = (value: string | null): TNormalizedBorderStyle | null => {
  if (!value) return null;

  const normalizedValue = value === 'hidden' ? 'none' : value;
  if (NORMALIZED_BORDER_STYLES.includes(normalizedValue as TNormalizedBorderStyle)) {
    return normalizedValue as TNormalizedBorderStyle;
  }

  return null;
};
